// Dictionary texts used from TS are rendered server-side: the Razor view puts the translated
// templates (Umbraco dictionary, English as fallback) on an element as data-* attributes, and
// these fill in the {0}/{1} placeholders.

export function formatText(template: string, ...args: (string | number)[]): string {
    return template.replace(/\{(\d+)\}/g, (match, index: string) => {
        const arg = args[Number(index)];
        return arg === undefined ? match : String(arg);
    });
}

// Counts ("{0} companies"): data-text-one / data-text-other on `element`, picked by `count`.
export function countText(element: HTMLElement, count: number): string {
    const template = (count === 1 ? element.dataset.textOne : element.dataset.textOther) ?? "{0}";
    return formatText(template, count);
}
